import authService from './AuthService';

/**
 * Merge Entra/SWA user identity onto API request headers.
 * Safe to call before auth has resolved — returns original headers if unknown.
 * @param {Record<string, string>} headers
 * @returns {Record<string, string>}
 */
export const withIdentityHeaders = (headers = {}) => ({
    ...headers,
    ...authService.getIdentityHeaders()
});
